<p>intercommunalite works!</p>
